import { useAbility } from "@casl/react";
import { PermissionString, Actions, Subjects } from "@/lib/auth/ability";

export function useCan() {
  const ability = useAbility();

  const can = (permission: PermissionString): boolean => {
    if (!ability) {
      return false;
    }
    const [subject, action] = permission.split(".");
    return ability.can(action as Actions, subject as Subjects);
  };

  return can;
}
